<template>
    <main-filter>
        <div class="filters__item filters__item--2 filters__item--mini">
			<div class="filters__item--double">
				<InputSelect :label="'Статус'" :inputGray="true">
					<template #select>
						<Multiselect
							v-model="status"
							:options="getTendersStatuses"
							:label="'name'"
							:value-prop="'id'"
							:placeholder="'Все'"
						/>
					</template>
				</InputSelect>
				<InputText :label="'Название товара'" v-model="product" :inputGray="true" />
			</div>
        </div>
        <div class="filters__item filters__item--3 filters__item--mini"></div>

        <div class="filters__item filters__item--2">
            <input-period v-model="auctionStart" :label="'Дата начала торгов'" :inputGray="true"></input-period>
        </div>
        <div class="filters__item filters__item--2">
            <input-period v-model="auctionEnd" :label="'Дата окончания торгов'" :inputGray="true"></input-period>
        </div>

        <div class="filters__item filters__item--2">
            <input-period v-model="supplyTime" :label="'Срок поставки'" :inputGray="true"></input-period>
        </div>

        <div class="filters__item filters__item--2">
            <input-period-volume v-model="lotSize" :label="'Объем поставки'" :inputGray="true">
                <template #select>
                    <Multiselect
                        v-model="unit"
                        :options="getProductsUnits"
                        :label="'name'"
                        :value-prop="'id'"
                    />
                </template>
            </input-period-volume>
        </div>

        <div class="filters__item filters__item--2">
            <div class="filters__btns">
                <button type="submint" class="btn btn--color" @click="requestTendersList">Применить</button>
                <button class="btn btn--trans" @click="handleClearFilters">Сбросить фильтр</button>
            </div>
        </div>
    </main-filter>
</template>

<script>

import MainFilter from "@/components/blocks/MainFilter.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import InputPeriod from "@/components/base/utils/formElements/InputPeriod.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import {mapActions, mapGetters} from "vuex";
import InputPeriodVolume from "@/components/base/utils/formElements/InputPeriodVolume.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";

export default {
    name: "SupplyTendersFilter",
    components: {InputPeriodVolume, InputPeriod, InputSelect,  MainFilter, Multiselect,InputText},
    data() {
        return {
            auctionStart: [],
            auctionEnd: [],
            supplyTime: [],
            lotSize: []
        }
    },
    created() {
        this.loadFilters();
    },
    watch: {
        auctionStart: {
            handler(newValue) {
                const val1 = newValue[0] ? this.getLocaleDateAndTime(newValue[0]) : null;
                const val2 = newValue[1] ? this.getLocaleDateAndTime(newValue[1]) : null;

                this.updateFilter({key: 'auctionStartFrom', value: val1})
                this.updateFilter({key: 'auctionStartTo', value: val2})
            },
            deep: true
        },
        auctionEnd: {
            handler(newValue) {
                const val1 = newValue[0] ? this.getLocaleDateAndTime(newValue[0]) : null;
                const val2 = newValue[1] ? this.getLocaleDateAndTime(newValue[1]) : null;

                this.updateFilter({key: 'auctionEndFrom', value: val1})
                this.updateFilter({key: 'auctionEndTo', value: val2})
            },
            deep: true
        },
        supplyTime: {
            handler(newValue) {
                const val1 = newValue[0] ? new Date(newValue[0]).toLocaleDateString() : null;
                const val2 = newValue[1] ? new Date(newValue[1]).toLocaleDateString() : null;

                this.updateFilter({key: 'supplyTimeFrom', value: val1})
                this.updateFilter({key: 'supplyTimeTo', value: val2})
            },
            deep: true
        },
        lotSize: {
            handler(newValue) {
                this.updateFilter({key: 'lotSizeFrom', value: newValue[0] || null})
                this.updateFilter({key: 'lotSizeTo', value: newValue[1] || null})
            },
            deep: true
        },
    },
    computed: {
        status: {
            get() {
                return this.getTendersFilter('status');
            },
            set(value) {
                this.updateFilter({key: 'status', value})
            }
        },
        unit: {
            get() {
                return this.getTendersFilter('unit');
            },
            set(value) {
                this.updateFilter({key: 'unit', value})
            }
        },
        offset: {
            get() {
                return this.getTendersFilter('offset');
            },
            set(value) {
                this.updateFilter({key: 'offset', value})
            }
        },
        limit: {
            get() {
                return this.getTendersFilter('limit');
            },
            set(value) {
                this.updateFilter({key: 'limit', value})
            }
        },
        product: {
            get() {
                return this.getTendersFilter('product');
            },
            set(value) {
                this.updateFilter({key: 'product', value})
            }
        },
        ...mapGetters({
            getTendersFilter: 'tenders/getTendersFilter',
            getTendersStatuses: 'tenders/getTendersStatuses',
            getProductsUnits: 'products/getProductsUnits',
        })
    },
    methods: {
        async loadFilters() {
            await this.requestTendersStatuses();
            await this.requestProductsUnits();
        },
        handleClearFilters() {
            this.auctionStart = []
            this.auctionEnd = []
            this.supplyTime = []
            this.lotSize = []
            this.resetFilter();
        },
        getLocaleDateAndTime(value) {
            const date = new Date(value).toLocaleDateString();
            const time = new Date(value).toLocaleTimeString();
            return `${date} ${time}`
        },
        ...mapActions({
            updateFilter: 'tenders/updateFilterKey',
            resetFilter: 'tenders/resetFilter',
            requestTendersStatuses: 'tenders/requestTendersStatuses',
            requestTendersList: 'tenders/requestTendersList',
            requestProductsUnits: 'products/requestProductsUnits',
        }),
    }

}
</script>


